import { css, RuleSet } from 'styled-components';
import { TypographyMode } from './typography.model';

export const implementModeVariant = (mode: TypographyMode) => {
    const implementation: { [key in TypographyMode]: RuleSet<object> } = {
        bold: css`
            font-weight: 700 !important;
        `,
        default: css``,
        light: css`
            font-weight: 300 !important;
        `,
        medium: css`
            font-weight: 500 !important;
        `,
        regular: css`
            font-weight: 400 !important;
        `,
    };

    return implementation[mode] || css``;
};
